import { useContext } from 'react'

import { MODALS_ID } from '../../../constants'

import { ModalContext } from '../../../provider/ModalProvider'

import { useNavigate } from '../../../hooks/useNavigate'

import { signOut } from '../../../api/auth'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

export function LogoutModal() {
  const { closeModal } = useContext(ModalContext)

  const navigate = useNavigate()

  const close = () => closeModal(MODALS_ID.LOGOUT)

  const logout = async () => {
    await signOut()
    navigate('/home')
    close()
  }

  return (
    <Modal id={MODALS_ID.LOGOUT}>
      <Text size={16} weight={500} lineHeight={24} $textAlign="center">
        로그아웃 하시겠어요?
      </Text>
      <Modal.Footer>
        <Button onClick={close}>취소</Button>
        <Button type="primary" onClick={logout}>
          네
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
